// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront20: FC<Storefront20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M17 9.5v5.992c0 .415-.147.77-.44 1.065A1.44 1.44 0 0 1 15.5 17h-11c-.413 0-.766-.15-1.06-.448A1.452 1.452 0 0 1 3 15.5V9.48c-.458-.32-.747-.73-.865-1.23a3.486 3.486 0 0 1 .01-1.583L3.106 4c.069-.333.228-.583.478-.75.25-.167.554-.25.91-.25h11.014c.356 0 .656.076.9.23.242.152.405.409.489.77l.958 2.667a3.387 3.387 0 0 1 0 1.583c-.125.5-.41.917-.854 1.25Zm-5.167-1c.292 0 .538-.097.74-.292a.824.824 0 0 0 .26-.708l-.5-3h-1.5v2.992c0 .283.098.522.292.716.194.195.43.292.708.292Zm-3.677 0a.977.977 0 0 0 .719-.292.974.974 0 0 0 .292-.716V4.5h-1.5l-.5 3a.824.824 0 0 0 .26.708c.201.195.445.292.73.292ZM4.5 8.5c.25 0 .469-.076.656-.23a.857.857 0 0 0 .323-.582L6 4.5H4.5l-.938 2.667a.965.965 0 0 0 .125.906.93.93 0 0 0 .813.427Zm11 0a.956.956 0 0 0 .823-.427.95.95 0 0 0 .135-.906L15.5 4.5H14l.52 3.188c.029.236.14.43.334.583.195.153.41.229.646.229Zm-11 7h11V10c-.347 0-.677-.066-.99-.198a2.376 2.376 0 0 1-.843-.614c-.25.277-.53.482-.841.614-.31.132-.642.198-.993.198-.35 0-.676-.07-.98-.208A2.924 2.924 0 0 1 10 9.188a2.38 2.38 0 0 1-.833.604c-.32.139-.653.208-1 .208-.348 0-.674-.059-.98-.177-.305-.118-.59-.33-.854-.636-.306.3-.608.51-.906.631A2.443 2.443 0 0 1 4.5 10v5.5Zm11 0h-11 .01-.014H15.5h-.022.021Z" />
        </svg>
    );
};

export default Storefront20;
